<template>
	<div :class="{ 'invalid': isInvalid }">
		<multiselect
			v-model="value"
			:options="options"
			:multiple="isMultiple"
			:placeholder="placeholder"
			:tagPlaceholder="tagPlaceholder"
			:selectLabel="selectLabel"
			@close="onTouch"
			label="value"
			track-by="key"
			:close-on-select="false"
			:clear-on-select="false"
			:hide-selected="true"
			:closeOnSelect="isCloseOnSelect"
			:disabled="isDisabled"
		/>
		<label class="typo__label form__label" v-show="isInvalid">{{invalidText}}</label>
		<template slot="singleLabel" slot-scope="props"><img class="option__image" :src="props.option.img" alt="No Man’s Sky"><span class="option__desc"><span class="option__title">{{ props.option.title }}</span></span></template>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
	name: 'CVueSelect',
	components: { Multiselect },
	data () {
		return {
			value: [],
			isTouched: false,
		}
	},
	props: {
		isDisabled: {
			type: Boolean,
			default: false
		},
		preset: Array | Object,
		isCloseOnSelect: {
			type: Boolean,
			default: false,
		},
		invalidText: {
			type: String,
			default: "Required",
		},
		selectLabel: {
			type: String,
			default: null,
		},
		tagPlaceholder: {
			type: String,
			default: null,
		},
		callGetValue: {
			type: Function,
			default: ()=>{}
		},
		isRequired: {
			type: Boolean,
			default: false
		},
		placeholder: String,
		isMultiple: {
			type: Boolean,
			default: false
		},
		options: {
			type: Array,
			default: ()=>[]
		}
	},
	mounted() {
		if (this.preset) {
			this.value = this.preset;
		}
	},
	computed: {
		isInvalid () {
			return (this.isTouched && this.isRequired && (!this.value || this.value.length === 0));
		}
	},
	watch: {
		value(newVal) {
			this.$emit("callGetValue", {value: newVal});
		}
	},
	methods: {
		onTouch () {
			this.isTouched = true;
		}
	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">

.invalid >>> .multiselect__tags {
	border-color: #FF2D47 !important;
}

/deep/ .multiselect .multiselect__tags {
	padding: 4px;
	border-radius: 4px;
	border: 1px solid #e8e8e8;
	background: #fff;
	font-size: 12px;
	min-height: unset;
}

/deep/ i.multiselect__tag-icon:hover {
	background-color: #cce6ff;
}

/deep/ .multiselect__tag-icon:after {
	color: #408bd3;
}

/deep/ .multiselect__tag {
	background-color: #e5f3ff;
	color: #408bd3;
	white-space: inherit;
	margin-right: 20px;
}

/deep/ .multiselect, .multiselect__input, .multiselect__single {
    font-family: inherit;
	min-height: unset;
}

/deep/ input.multiselect__input {
    font-size: 12px;
	margin: 0;
}

/deep/ .multiselect__placeholder {
	min-width: 140px;
}

/deep/ .multiselect__select {
	top: unset;
	height: 25px;
	width: 0;
	right: 18px;
	padding: 0;
}

/deep/ .multiselect--active .multiselect__select {
	transform: rotateX(180deg);
}

/deep/ .multiselect__placeholder {
	margin: 0;
	padding: 0;
}

/deep/ .multiselect__content-wrapper {
	width: unset;
	border-radius: 4px
}

/deep/ span.multiselect__option.multiselect__option--highlight {
	color: #222;
	background-color: #f3f4f5;
}

/deep/ span.multiselect__option {
	font-size: 12px;
	padding: 8px
}

/deep/ label.typo__label.form__label {
	font-size: 12px;
	color: #FF2D47;
}
</style>


// WEBPACK FOOTER //
// src/components/common/OptionSelect/CVueSelect.vue